import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const buyForMeAPI = createApi({
  reducerPath: 'buyForMeAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/app/invoice/',
    prepareHeaders: (headers, { getState }) => {
      let { auth: { auth } } = getState();
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["order"],
  endpoints: (builder) => ({
    getListBuyForMe: builder.query({
      query: (id) => {
        return {
          url: `listBuyForMe`,
          params: {
            status: id
          }
        }
      },
      providesTags: ["order"],
    }),
    changeBuyForMe: builder.query({
      query: ({ partial, partial_code }) => {
        return {
          url: `manifest-data`,
          params: {
            partial: partial,
            partial_code: partial_code
          }
        }
      },
    }),
    takeBuyForMeToProcessing: builder.mutation({
      query: ({ guid, user_email, invoice_guid }) => ({
        url: `take-proccess`,
        method: 'POST',
        body: { guid, email: user_email, invoice_guid },
      }),
      invalidatesTags: ["buyforme"], // обновляем список заказов после взятия в обработку
    }),

  }),
})

export const { useGetListBuyForMeQuery, useTakeBuyForMeToProcessingMutation } = buyForMeAPI